import React, { useEffect } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Button,
} from "@material-tailwind/react";
import { moviesData, ebooksData } from "../Constant/Data";
import MyItemsCard from "./MyItemsCard.jsx";
import { useReduxStore } from "../hooks/useReduxStore";
import { GetWishlistItemsAction } from "../store/Actions/action";
import EmptyList from "./EmptyList";
export default function MyWishlistSection({ selected = "All", dark = true }) {
  const { dispatch, getState } = useReduxStore();
  const { wishlistItems } = getState("AUTH");
  const getWishlist = () => dispatch(GetWishlistItemsAction());
  useEffect(() => {
    getWishlist();
  }, []);
  return (
    <div className={`w-full rounded-xl p-4 md:p-8 shadow-2xl border ${
      dark 
        ? "bg-zinc-950 border-zinc-900 text-white" 
        : "bg-white border-gray-100 text-black md:shadow-lg"
    }`}>
      <div className="flex justify-between items-center py-4">
        <h4 className={`text-xl font-bold sm:text-3xl text-center lg:text-left ${dark ? "text-white" : "text-black"}`}>
          Your Wishlist
        </h4>
      </div>
      {!wishlistItems?.length ? (
        <EmptyList dark={dark} btn={false} />
      ) : (
        <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-2 xl:grid-cols-2 3xl:grid-cols-2 mt-4">
          {wishlistItems.map((item, i) =>
            item?.product ? (
              <li key={item?.product?.id || i}>
                <MyItemsCard {...item?.product} item={item?.product} dark={dark} />
              </li>
            ) : null
          )}
        </ul>
      )}
    </div>
  );
}
